import { FeaturePageRouteContent } from "@/features/feature-page/feature-page-route-content";
import { Route } from "/app/apps/web/src/routes/_app/$lang/$family/$slug/index.tsx";
function FeaturePageRoute() {
  const {
    family,
    locale,
    slug
  } = Route.useLoaderData();
  return <FeaturePageRouteContent family={family} slug={slug} locale={locale} />;
}
export { FeaturePageRoute as component };